import api from "./api";

export const changePassword = (data) =>
  api.post("/accounts/change-password/", data);
